import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "./Journal.css";

const Journal = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      setError("");

      const { data, error } = await supabase
        .from("journal_articles")
        .select(`
          id,
          title,
          slug,
          excerpt,
          cover_image,
          category,
          published_at
        `)
        .eq("published", true)
        .order("published_at", { ascending: false });

      if (error) {
        console.error("Error fetching journal articles:", error);
        setError("Unable to load journal articles. Please try again later.");
        setArticles([]);
      } else {
        setArticles(data || []);
      }

      setLoading(false);
    };

    fetchArticles();
  }, []);

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="journal-page">
      <Navbar />

      <main className="journal-main">

        {/* Hero */}
        <section className="journal-hero">
          <div className="journal-hero-inner">

            <span className="journal-eyebrow">
              FROM THE PRACTICE
            </span>

            <h1>
              Sudhamshu Ayurveda
              <br />
              <span>Journal</span>
            </h1>

            <p>
              Thoughtful perspectives on Ayurveda, health, wellness,
              lifestyle and traditional healing from our practice.
            </p>

          </div>
        </section>

        {/* Articles */}
        <section className="journal-list-section">

          <div className="journal-section-heading">
            <div>
              <span className="journal-section-eyebrow">
                INSIGHTS & EDUCATION
              </span>

              <h2>
                Explore our latest articles
              </h2>
            </div>

            {!loading && !error && articles.length > 0 && (
              <span className="journal-article-count">
                {articles.length}{" "}
                {articles.length === 1 ? "Article" : "Articles"}
              </span>
            )}
          </div>

          {/* Loading */}
          {loading && (
            <div className="journal-state">
              <div className="journal-spinner"></div>
              <p>Loading journal articles...</p>
            </div>
          )}

          {/* Error */}
          {!loading && error && (
            <div className="journal-state journal-error-state">
              <h3>Something went wrong</h3>
              <p>{error}</p>
            </div>
          )}

          {/* Empty */}
          {!loading && !error && articles.length === 0 && (
            <div className="journal-state journal-empty-state">
              <span className="journal-empty-mark">✦</span>

              <h3>Our journal is growing</h3>

              <p>
                New articles and insights from our practice
                will appear here soon.
              </p>
            </div>
          )}

          {/* Articles */}
          {!loading && !error && articles.length > 0 && (
            <div className="journal-grid">

              {articles.map((article) => (
                <article
                  className="journal-card"
                  key={article.id}
                >

                  <Link
                    to={`/journal/${article.slug}`}
                    className="journal-card-link"
                  >

                    {/* Image */}
                    <div className="journal-card-image">

                      {article.cover_image ? (
                        <img
                          src={article.cover_image}
                          alt={article.title}
                          loading="lazy"
                        />
                      ) : (
                        <div className="journal-card-image-placeholder">
                          <span>Sudhamshu Ayurveda</span>
                        </div>
                      )}

                    </div>

                    {/* Content */}
                    <div className="journal-card-content">

                      <div className="journal-card-meta">

                        {article.category && (
                          <span className="journal-card-category">
                            {article.category}
                          </span>
                        )}

                        {article.published_at && (
                          <span className="journal-card-date">
                            {formatDate(article.published_at)}
                          </span>
                        )}

                      </div>

                      <h3>
                        {article.title}
                      </h3>

                      {article.excerpt && (
                        <p>
                          {article.excerpt}
                        </p>
                      )}

                      <span className="journal-read-more">
                        Read Article
                        <span>→</span>
                      </span>

                    </div>

                  </Link>

                </article>
              ))}

            </div>
          )}

        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Journal;